import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import ListMenu from "../ListMenu/ListMenu";
import Logo from "../Logo/Logo";
import { Navbar } from "../Navbar/Navbar";

const Header = () => {
  const [toggle1, setToggle1] = useState(false);
  const [toggle2, setToggle2] = useState(false); 

  const toggleClasse = (e) => {
    console.log(toggle1, toggle2);
    setToggle1(!toggle1);
    setToggle2(!toggle2);
  };

  return (
    <>
      <div className="page_header">
        <div className="container">
          <div className="page_header__row">
            <div className="logo">
              <NavLink to="home">
                <Logo width="180px" />
              </NavLink>
            </div>
            <div>
              <Navbar />
              <div className="menu-icon">
                <button
                  className={toggle1 ? "toggle-menu active" : "toggle-menu"}
                  onClick={toggleClasse}
                >
                  <span></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="menu" className={toggle2 ? "open" : ""}>
        <button className={toggle1 ? "toggle-menu active" : "toggle-menu"} onClick={toggleClasse}>
          <span></span>
        </button>
        <div className="main-nav">
          <div className="container">
            <div className="nav-wrapper">
              <nav className="main-nav-menu">
                <ListMenu />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
